import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const Title = ({ text, url, as, theme, Tag, className, ariaHidden }) => {
	const titleCx = cx(styles.title, styles[`theme_${theme}`], className);

	return (
		<div className={titleCx} aria-hidden={ariaHidden}>
			{url ? (
				<NextLink href={url} as={as} className={styles.link}>
					{text}
					&nbsp;
					{theme === 'more' && (
						<span className={styles.iconWrapper}>
							<Icon icon="chevronRight" className={styles.icon} />
						</span>
					)}
				</NextLink>
			) : (
				<Tag className={styles.text}>{text}</Tag>
			)}
		</div>
	);
};

Title.propTypes = {
	Tag: PropTypes.oneOf(['span', 'h1', 'h2']),
	text: PropTypes.string.isRequired,
	className: PropTypes.string,
	url: PropTypes.string,
	as: PropTypes.string,
	theme: PropTypes.oneOf(['more']),
	ariaHidden: PropTypes.bool
};

Title.defaultProps = {
	Tag: 'span'
};

export default Title;
